module.exports = __webpack_public_path__ + "img/Maradona-6.83ec6e50.webp";